import { defaultTxt, isDash } from '@miq/utils';
import { displayFnWrapper } from '../../utils/dynamic-data-retrievers';
import { displayFnWrapperArrayFlatter } from './common-display-fn';

function displayFnWrapperAddOnFactor(record, _, addOnFactorArg) {
  // get value and check for null
  const arrayValue = displayFnWrapper(record, _, addOnFactorArg);
  if (arrayValue == null) {
    return defaultTxt;
  }

  // set value to use, even if original value is an array
  let factor = arrayValue;
  if (Array.isArray(factor)) {
    factor = arrayValue[0];
    if (factor == null || isDash(factor)) {
      return defaultTxt;
    }
  }

  // convert and check for NaN
  const factorNum = Number(factor);
  if (isNaN(factorNum)) {
    return defaultTxt;
  }

  return `${factorNum.toFixed(2)}%`;
}

export const emeaAddOnFactorFunctions = {
  421: {
    // 421 - add-on factor (Poland )
    displayFn: displayFnWrapperAddOnFactor,
  },
  431: {
    // 431 - add-on factor (Italy)
    displayFn: displayFnWrapperArrayFlatter,
  },
  508: {
    // 508 - add-on factor (Finland)
    displayFn: displayFnWrapperArrayFlatter,
  },
  518: {
    // 518 - add-on factor (Norway)
    displayFn: displayFnWrapperArrayFlatter,
  },
  498: {
    // 498 - add-on factor (Sweden)
    displayFn: displayFnWrapperArrayFlatter,
  },
};
